import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { DropzoneArea } from 'material-ui-dropzone';
import { makeStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import is from 'is_js';
import { MAX_FILE_SIZE } from '../../constants/commonConstants';

const useStyles = makeStyles((theme) => ({
  dropzoneError: {
    borderColor: theme.palette.error.main,
  },
}));

const FormUpload = ({
  id,
  showFileNames,
  maxFileSize,
  showAlerts,
  initialFiles,
  acceptedFiles,
  disabled,
}) => {
  const classes = useStyles();

  const {
    control,
    formState: { errors },
  } = useFormContext();
  const inError = is.truthy(errors[id]);
  const dropzoneClass = inError ? { root: classes.dropzoneError } : {};
  const inputPropsClass = disabled ? { disabled: true } : {};
  const formHelperText = inError ? 'This field is required' : '';

  return (
    <>
      <Controller
        name={id}
        control={control}
        render={({ field }) => (
          <>
            <DropzoneArea
              {...field}
              initialFiles={initialFiles}
              classes={dropzoneClass}
              showFileNames={showFileNames}
              maxFileSize={maxFileSize}
              showAlerts={showAlerts}
              filesLimit={1}
              acceptedFiles={acceptedFiles}
              inputProps={inputPropsClass}
            />
            <FormHelperText error={inError}>{formHelperText}</FormHelperText>
          </>
        )}
      />
    </>
  );
};

FormUpload.defaultProps = {
  showFileNames: true,
  maxFileSize: MAX_FILE_SIZE,
  showAlerts: ['error', 'info'],
  initialFiles: [],
  acceptedFiles: [],
  disabled: false,
};

FormUpload.propTypes = {
  id: PropTypes.string.isRequired,
  showFileNames: PropTypes.bool,
  maxFileSize: PropTypes.number,
  showAlerts: PropTypes.array,
  initialFiles: PropTypes.array,
  acceptedFiles: PropTypes.array,
  disabled: PropTypes.bool,
};

export default FormUpload;
